// @flow

import * as React from "react";
import { Button } from "react-bootstrap";

import "./Pagination.css";

type Props = {
  handlePrev: () => void,
  handleNext: () => void
};

const Pagination = (props: Props) => (
  <div className="Pagination">
    <Button type="button" onClick={props.handlePrev}>
      Previous Page
    </Button>
    <Button type="button" onClick={props.handleNext}>
      Next Page
    </Button>
  </div>
);

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/Google/Pagination.js